var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadcrumbs
    }
  }), _vm.loading ? [_c('Loader', {
    attrs: {
      "content-id": _vm.txId,
      "message": 'Fetching Transaction Details'
    }
  })] : [!_vm.tx ? _c('HTTPError', {
    attrs: {
      "id": _vm.txId,
      "title": 'Transaction Details Not Found',
      "message": 'A record for this transaction ID was not found in the Avalanche Explorer',
      "support-u-r-l": 'https://chat.avalabs.org'
    }
  }) : [_c('TransactionSummary', {
    attrs: {
      "tx": _vm.tx
    }
  }, [_vm._v(" " + _vm._s(_vm._f("getType")(_vm.tx.type)) + " Transaction ")]), _c('TransactionUTXO', {
    attrs: {
      "tx": _vm.tx
    }
  })]]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }